import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import { createQueryKey } from '@/lib/react-query'
import { createFormData } from '@/utils/api.util'
import storage from '@/utils/storage'

const resource = API_RESOURCE.OFFER_COST_BUDGET

const OfferBudgetService = {
  resource: resource,
  queryKey: createQueryKey(resource),

  getVendorCostBudgetDetail: async ({ costBudgetId }) => {
    const response = await axios.get(`${resource}/${costBudgetId}`)

    return response.data
  },

  getVendorAllFilesZip: async ({ offerId, costBudgetIndex, vendorIndex }) => {
    const response = await axios.get(
      `${resource}/${offerId}/costBudgets/${costBudgetIndex}/vendors/${vendorIndex}/file`,
      {
        responseType: 'blob',
      }
    )

    return response.data
  },

  vendorUploadQuotation: async ({ costBudgetId, ...rest }) => {
    console.log('123')
    const response = await axios.post(`${resource}/${costBudgetId}/quotations`, rest)

    return response.data
  },

  vendorDeclineQuotation: async ({ costBudgetId, remark }) => {
    const response = await axios.put(`${resource}/${costBudgetId}/reject`, { remark: remark })

    return response.data
  },
  vendorUploadFrameAgreement: async ({ costBudgetId, ...rest }) => {
    const response = await axios.post(`${resource}/${costBudgetId}/frameAgreements`, rest)

    return response.data
  },
}
export default OfferBudgetService
